(() => {
  const root = document.querySelector('[data-lds-matte-v2]');
  if (!root) return;
  const variantNode = root.querySelector('[data-lds-variants]');
  const form = root.querySelector('[data-lds-form]');
  if (!variantNode || !form) return;
  const variants = JSON.parse(variantNode.textContent || '[]');
  const groups = [...root.querySelectorAll('[data-option-index]')];
  const colorGroups = groups.filter(group => group.dataset.optionKind === 'color' || group.classList.contains('lds-matte-v2__option--color'));
  const legacyBlueGroups = new Set(colorGroups.filter(group => [...group.querySelectorAll('[data-option-value]')].some(button => /^NAVY BLUE$/i.test(button.dataset.optionValue || '')) && ![...group.querySelectorAll('[data-option-value]')].some(button => /^(ICE BLUE|ICE_BLUE|Ice Blue)$/.test(button.dataset.optionValue || ''))));
  const canonicalOptionLabel = (value, index) => {
    const group = groups.find(item => Number(item.dataset.optionIndex) === index);
    if (!colorGroups.includes(group)) return value;
    if (/^NAVY BLUE$/i.test(value)) return 'Blue';
    if (value === 'BLUE') return legacyBlueGroups.has(group) ? 'Ice Blue' : 'Blue';
    if (value === 'Blue') return 'Blue';
    if (/^(ICE BLUE|ICE_BLUE|Ice Blue)$/.test(value)) return 'Ice Blue';
    return value;
  };
  const canonicalVariantSummary = variant => variant.options.map((option, index) => canonicalOptionLabel(option, index)).join(' / ');
  const syncSticky = (variant, valid) => {
    const summary = root.querySelector('[data-lds-sticky-summary]');
    const stickyPrice = root.querySelector('[data-lds-sticky-price]');
    const stickyAdd = root.querySelector('[data-lds-sticky-add]');
    if (summary) { summary.textContent = canonicalVariantSummary(variant); summary.dataset.variantId = String(variant.id); summary.dataset.available = valid ? 'true' : 'false'; summary.dataset.color = variant.options[colorGroups.length ? Number(colorGroups[0].dataset.optionIndex) : -1] || ''; }
    if (stickyPrice) { stickyPrice.textContent = formatMoney(variant.price); stickyPrice.dataset.variantId = String(variant.id); stickyPrice.dataset.available = valid ? 'true' : 'false'; }
    if (stickyAdd) { stickyAdd.disabled = !valid; stickyAdd.dataset.variantId = String(variant.id); stickyAdd.dataset.available = valid ? 'true' : 'false'; stickyAdd.setAttribute('aria-disabled', valid ? 'false' : 'true'); stickyAdd.textContent = valid ? 'Add to cart' : 'Unavailable'; }
  };
  const variantId = form.querySelector('[name="id"]');
  const quantity = form.querySelector('[name="quantity"]');
  const price = root.querySelector('[data-lds-price]');
  const compare = root.querySelector('[data-lds-compare]');
  const discount = root.querySelector('[data-lds-discount]');
  const addButtons = [...root.querySelectorAll('[data-lds-add]')];
  const status = root.querySelector('[data-lds-status]');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const fallbackMoney = value => new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }).format(Number(value || 0) / 100);
  const formatMoney = value => window.Shopify?.formatMoney ? window.Shopify.formatMoney(value, moneyFormat) : fallbackMoney(value);
  const purchasePanel = window.LdsPurchasePanel.install(root, {form, formatMoney, quantityRules: JSON.parse(document.getElementById(`LdsPurchaseRules-${root.dataset.productId}`).textContent)});
  const getSelections = () => {
    const selections = [];
    groups.forEach(group => { selections[Number(group.dataset.optionIndex)] = group.querySelector('.is-selected')?.dataset.optionValue || ''; });
    return selections;
  };
  const optionAvailable = (index, value, selections) => variants.some(variant => variant.available && variant.options.every((option, optionIndex) => optionIndex === index ? option === value : !selections[optionIndex] || option === selections[optionIndex]));
  const findVariant = selections => variants.find(variant => variant.options.every((option, index) => option === selections[index]));
  const surfaceDelta = (selected, surfaceValue) => {
    if (!selected || !surfaceValue) return '';
    if (!/RAPTOR/i.test(surfaceValue)) return '';
    const selections = [...selected.options];
    const surfaceIndex = Number(groups.find(group => group.querySelector(`[data-option-value="${CSS.escape(surfaceValue)}"]`))?.dataset.optionIndex ?? 2);
    selections[surfaceIndex] = surfaceValue;
    const raptor = findVariant(selections);
    const stainlessValue = groups.find(group => Number(group.dataset.optionIndex) === surfaceIndex)?.querySelector('[data-option-value]:not([data-option-value*="RAPTOR"])')?.dataset.optionValue;
    if (!raptor || !stainlessValue) return '';
    const stainlessSelections = [...selections];
    stainlessSelections[surfaceIndex] = stainlessValue;
    const stainless = findVariant(stainlessSelections);
    const delta = stainless ? Number(raptor.price) - Number(stainless.price) : 0;
    return delta > 0 ? `+${formatMoney(delta)}` : '';
  };
  const updateUrl = id => { const url = new URL(window.location.href); url.searchParams.set('variant', id); window.history.replaceState({}, '', url); };
  function update() {
    const selections = getSelections();
    groups.forEach(group => {
      const index = Number(group.dataset.optionIndex);
      group.querySelectorAll('[data-option-value]').forEach(button => {
        const value = button.dataset.optionValue;
        button.disabled = !optionAvailable(index, value, selections);
        button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
      });
    });
    const selected = findVariant(selections);
    const valid = Boolean(selected?.available);
    if (selected) {
      variantId.value = selected.id;
      price.textContent = formatMoney(selected.price);
      if (selected.compare_at_price && Number(selected.compare_at_price) > Number(selected.price)) {
        compare.textContent = formatMoney(selected.compare_at_price); compare.hidden = false;
        discount.textContent = `-${Math.round((1 - Number(selected.price) / Number(selected.compare_at_price)) * 100)}%`; discount.hidden = false;
      } else { compare.hidden = true; discount.hidden = true; }
      updateUrl(selected.id);
      syncSticky(selected, valid);
      root.querySelectorAll('[data-surface-delta]').forEach(node => { const button = node.closest('[data-option-value]'); if (button) node.textContent = surfaceDelta(selected, button.dataset.optionValue); });
    }
    addButtons.forEach(button => { button.disabled = !valid; button.textContent = valid ? `Add to cart · ${selected ? formatMoney(selected.price) : ''}` : 'Unavailable'; });
    status.textContent = valid ? '' : 'This combination is unavailable.';
    purchasePanel.render(selected, valid);
  }
  groups.forEach(group => group.addEventListener('click', event => {
    const button = event.target.closest('[data-option-value]');
    if (!button || button.disabled) return;
    group.querySelectorAll('[data-option-value]').forEach(item => item.classList.toggle('is-selected', item === button));
    update();
  }));
  root.querySelector('[data-lds-sticky-add]')?.addEventListener('click', () => form.requestSubmit());
  form.addEventListener('submit', () => addButtons.forEach(button => { button.disabled = true; }));
  const slides = [...root.querySelectorAll('[data-lds-slide]')];
  const thumbs = [...root.querySelectorAll('[data-lds-thumb]')];
  let mediaIndex = 0;
  const pauseVideos = () => slides.forEach(slide => slide.querySelectorAll('iframe').forEach(frame => frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*')));
  const showMedia = index => { if (!slides.length) return; pauseVideos(); mediaIndex = (index + slides.length) % slides.length; const activeSlide = slides[mediaIndex]; slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === mediaIndex); slide.setAttribute('aria-hidden', i === mediaIndex ? 'false' : 'true'); }); root.querySelector('[data-lds-main-media]')?.classList.toggle('is-video', activeSlide?.dataset.mediaKind === 'external_video'); thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === mediaIndex); thumb.setAttribute('aria-current', i === mediaIndex ? 'true' : 'false'); }); root.querySelector('[data-lds-current]').textContent = String(mediaIndex + 1); thumbs[mediaIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }); };
  root.querySelector('[data-lds-prev]')?.addEventListener('click', () => showMedia(mediaIndex - 1));
  root.querySelector('[data-lds-next]')?.addEventListener('click', () => showMedia(mediaIndex + 1));
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
  root.querySelector('[data-lds-main-media]')?.addEventListener('keydown', event => { if (event.key === 'ArrowLeft') showMedia(mediaIndex - 1); if (event.key === 'ArrowRight') showMedia(mediaIndex + 1); });
  let touchStartX = 0;
  root.querySelector('[data-lds-main-media]')?.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  root.querySelector('[data-lds-main-media]')?.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchStartX; if (Math.abs(delta) > 45) showMedia(mediaIndex + (delta < 0 ? 1 : -1)); }, { passive: true });
  showMedia(0); update();
  const anchorNav = root.querySelector('[data-lds-anchor-nav]');
  if (anchorNav) {
    const anchorLinksWrap = anchorNav.querySelector('.lds-matte-v2__anchor-links');
    const anchorLinks = [...anchorNav.querySelectorAll('a[data-lds-anchor-link]')];
    const activeIndicator = anchorNav.querySelector('[data-lds-active-indicator]');
    const targetIds = ['details', 'installation', 'reviews', 'faq', 'build-your-set'];
    const targets = targetIds.map(id => document.getElementById(id)).filter(Boolean);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer;
    let measuredHeaderBottom = -1;
    let measuredNavHeight = -1;
    let correctionTimer;
    const headerBottom = () => {
      const headers = [...document.querySelectorAll('header')];
      const bottoms = headers.map(header => header.getBoundingClientRect()).filter(rect => rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight).map(rect => rect.bottom);
      return bottoms.length ? Math.max(...bottoms) : 0;
    };
    const moveIndicator = () => {
      const active = anchorLinks.find(link => link.getAttribute('aria-current') === 'true');
      if (!active || !activeIndicator || !anchorLinksWrap) return;
      const label = [...active.querySelectorAll('[data-lds-anchor-label]')].find(node => getComputedStyle(node).display !== 'none');
      if (!label) return;
      const labelRect = label.getBoundingClientRect();
      const linksRect = anchorLinksWrap.getBoundingClientRect();
      activeIndicator.style.width = `${Math.round(labelRect.width)}px`;
      activeIndicator.style.transform = `translateX(${Math.round(labelRect.left - linksRect.left)}px)`;
    };
    const setActive = id => {
      const previous = anchorLinks.find(link => link.getAttribute('aria-current') === 'true')?.getAttribute('href');
      anchorLinks.forEach(link => {
        const active = link.getAttribute('href') === `#${id}`;
        if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
      moveIndicator();
      if (!["8642596339869", "8641609662621"].includes(root.dataset.productId) && !root.hasAttribute('data-lds-sill-pilot') && window.innerWidth <= 600 && previous !== `#${id}`) anchorLinks.find(link => link.getAttribute('href') === `#${id}`)?.focus({ preventScroll: true });
    };
    const syncActive = () => {
      const headerBottom = Number.parseFloat(getComputedStyle(root).getPropertyValue('--lds-matte-v2-header-bottom')) || 0;
      const navHeight = Number.parseFloat(getComputedStyle(root).getPropertyValue('--lds-matte-v2-nav-height')) || 54;
      const visibilityLine = headerBottom + navHeight + 14;
      const candidates = targets.map(target => ({ target, rect: target.getBoundingClientRect() })).filter(item => item.rect.top <= window.innerHeight * .35 && item.rect.bottom > visibilityLine).sort((a, b) => b.rect.top - a.rect.top);
      setActive((candidates[0]?.target || targets[0]).id);
    };
    const measureOffset = () => {
      const currentHeaderBottom = Math.ceil(headerBottom());
      const navHeight = Math.ceil(anchorNav.getBoundingClientRect().height || (window.innerWidth <= 600 ? 50 : 54));
      root.style.setProperty('--lds-matte-v2-nav-offset', `${currentHeaderBottom}px`);
      root.style.setProperty('--lds-matte-v2-header-bottom', `${currentHeaderBottom}px`);
      root.style.setProperty('--lds-matte-v2-nav-height', `${navHeight}px`);
      root.style.setProperty('--lds-matte-v2-anchor-margin', `${currentHeaderBottom + navHeight + 14}px`);
      if (currentHeaderBottom !== measuredHeaderBottom || navHeight !== measuredNavHeight) {
        measuredHeaderBottom = currentHeaderBottom;
        measuredNavHeight = navHeight;
        observer?.disconnect();
        observer = new IntersectionObserver(() => syncActive(), { rootMargin: `-${currentHeaderBottom + navHeight + 14}px 0px -52% 0px`, threshold: [0, .15, .35, .6] });
        targets.forEach(target => observer.observe(target));
      }
      moveIndicator();
      syncActive();
    };
    const targetScrollTop = target => {
      const stickyBottom = Number.parseFloat(getComputedStyle(root).getPropertyValue('--lds-matte-v2-header-bottom')) + Number.parseFloat(getComputedStyle(root).getPropertyValue('--lds-matte-v2-nav-height'));
      return Math.max(0, Math.round(window.scrollY + target.getBoundingClientRect().top - stickyBottom - 14));
    };
    const correctAfterScroll = target => {
      requestAnimationFrame(() => {
        measureOffset();
        window.scrollTo({ top: targetScrollTop(target), behavior: 'auto' });
        requestAnimationFrame(() => { measureOffset(); syncActive(); });
      });
    };
    const scrollToTarget = (target, behavior) => {
      window.clearTimeout(correctionTimer);
      window.scrollTo({ top: targetScrollTop(target), behavior });
      if (behavior === 'auto') {
        correctAfterScroll(target);
      } else if ('onscrollend' in window) {
        const onScrollEnd = () => { window.removeEventListener('scrollend', onScrollEnd); correctAfterScroll(target); };
        window.addEventListener('scrollend', onScrollEnd, { once: true });
        correctionTimer = window.setTimeout(() => { window.removeEventListener('scrollend', onScrollEnd); correctAfterScroll(target); }, 900);
      } else {
        correctionTimer = window.setTimeout(() => correctAfterScroll(target), 900);
      }
    };
    const scrollToHash = () => {
      const id = window.location.hash.replace(/^#/, '');
      const target = targetIds.includes(id) ? document.getElementById(id) : null;
      if (target) { setActive(id); scrollToTarget(target, reducedMotion.matches ? 'auto' : 'smooth'); }
    };
    anchorLinks.forEach(link => link.addEventListener('click', event => {
      const hash = link.getAttribute('href');
      if (!hash?.startsWith('#')) return;
      const target = document.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      history.pushState({}, '', hash);
      setActive(hash.slice(1));
      scrollToTarget(target, reducedMotion.matches ? 'auto' : 'smooth');
    }));
    measureOffset();
    if (targetIds.includes(window.location.hash.slice(1))) scrollToHash(); else syncActive();
    window.addEventListener('resize', measureOffset, { passive: true });
    window.addEventListener('scroll', syncActive, { passive: true });
    window.addEventListener('load', measureOffset, { once: true });
    const headerResizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measureOffset);
    document.querySelectorAll('header').forEach(header => headerResizeObserver?.observe(header));
    window.addEventListener('popstate', scrollToHash);
    window.addEventListener('hashchange', scrollToHash);
  }
})();
